import React from "react";
import { Box, Typography, LinearProgress, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

const GradientLinearProgress = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 6,
  overflow: "hidden",
  backgroundColor: "rgba(47,99,173,0.08)",

  "& .MuiLinearProgress-bar": {
    borderRadius: 6,
    backgroundImage: "linear-gradient(90deg,#2f63ad,#4f8ef7,#93c5fd)",
    backgroundSize: "200% auto",
    animation: "shimmer 3s linear infinite",
  },

  "@keyframes shimmer": {
    "0%": { backgroundPosition: "0% 50%" },
    "100%": { backgroundPosition: "200% 50%" },
  },
}));

const StorageStatus = ({ storageUsed, maxStorage }) => {
  const usedGB = (storageUsed / (1024 * 1024 * 1024)).toFixed(2);
  const maxGB = (maxStorage / (1024 * 1024 * 1024)).toFixed(0);

  const percentage = Math.min(
    ((storageUsed / maxStorage) * 100).toFixed(0),
    100
  );

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "16px",
        border: "1px solid rgba(47,99,173,0.08)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        backgroundColor: "rgba(255,255,255,0.96)",
        p: 2.5,
        mt: 2.5,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 700,
            color: "#223142",
          }}
        >
          Storage Usage
        </Typography>

        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: "#6b778c",
          }}
        >
          {usedGB} GB / {maxGB} GB
        </Typography>
      </Box>

      <GradientLinearProgress variant="determinate" value={percentage} />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 1,
        }}
      >
        <Typography variant="caption" sx={{ color: "#6b778c" }}>
          {percentage}% used
        </Typography>

        <Typography variant="caption" sx={{ color: "#6b778c" }}>
          {(maxGB - usedGB).toFixed(2)} GB remaining
        </Typography>
      </Box>
    </Paper>
  );
};

export default StorageStatus;